import { render, staticRenderFns } from "./AskQuestion.vue?vue&type=template&id=33e434cc&"
import script from "./AskQuestion.vue?vue&type=script&lang=ts&"
export * from "./AskQuestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports